import { Drawer } from "@mui/material";
import { InsightsScope } from "hooks/use-insights-scope";
import { InsightsPanel } from "./InsightsPanel";
import { INSIGHTS_FONT } from "./tokens";

export interface InsightsDrawerProps {
  open: boolean;
  onClose: () => void;
  scope: InsightsScope;
}

/**
 * O Insights sobreposto à tela de contratos do cliente.
 *
 * É painel e não navegação de propósito: quem abre no meio de um trabalho
 * normalmente só quer tirar uma dúvida, e trocar de rota descartaria o estado da
 * tela de baixo. Aqui nada é desmontado — fechar devolve a página exatamente
 * como estava.
 *
 * Ocupa a tela inteira porque o conteúdo pede: a grade de relatórios é de duas
 * colunas e o chat tem tabela de resultado. Uma faixa lateral obrigaria a rolar
 * na horizontal para ler o que o painel devolve.
 */
export function InsightsDrawer({ open, onClose, scope }: InsightsDrawerProps) {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      aria-label="Insights do cliente"
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#FFFFFF",
          fontFamily: INSIGHTS_FONT,
        },
      }}
    >
      {/* Aba inicial nos relatórios: o botão que trouxe o usuário até aqui está
          na tela de contratos, e o que ele recorta é o relatório. */}
      <InsightsPanel scope={scope} initialTab="relatorios" onClose={onClose} />
    </Drawer>
  );
}
